/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AdminRole {
    ADMIN = 'Admin',
    SUPER_ADMIN = 'SuperAdmin',
}
